module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_base.1001.jpg.astc.bc03af38.ktx";